var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"route-printed-tooltip\">\n  <div>\n    <div class=\"cell\"><span>{{ t('fleetPrinterName', '') }}</span></div>\n    <div class=\"cell right\"><span>{{ '#' }}</span></div>\n  </div>\n  <div ng-repeat=\"print in routePlan.prints\">\n    <div class=\"cell label\"><span>{{print.userName}}</span></div>\n    <div class=\"cell label right\"><span>{{print.numberOfPrints}}</span></div>\n  </div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/routePrintedTooltip.jade
 ** module id = 102
 ** module chunks = 1
 **/